import { styled } from '@linaria/react';

import { MqTablet } from '~theme/media';

export const ButtonsContainer = styled.div`
	display: flex;
	align-items: center;
	padding-left: 8px;
	gap: 10px;

	${MqTablet} {
		padding-left: 0;
	}
`;
